import { createRoutine } from 'redux-saga-routines';

export const setIsConnected = createRoutine('SET_IS_CONNECTED');
